<mat-drawer-container autosize>
  <ng-container *ngIf="dossier?.id > 0 && !byModal && (showComments() | async)">
    <button class="sitcky-btn" mat-raised-button color="primary" (click)="ctsread.toggle()">
      <mat-icon>message</mat-icon>
    </button>
  </ng-container>
  <mat-drawer class="comments" #ctsread position="end" mode="side">
    <ng-container *ngIf="dossier?.id > 0">
      <app-comments [ngStyle]="{'width': '350px', 'display':'block'}"
                    (changer)="ctsread.toggle()"
                    [opened]="ctsread.opened"
                    [commentator]="individuConnected"
                    [roles]="rolesConnecte"
                    [dossier]="dossier">
      </app-comments>
    </ng-container>
  </mat-drawer>
  <p8-layout-settings-page>
    <p8-layout-settings-header [titlePath]="['Dossier', getReference() ]"></p8-layout-settings-header>
    <mat-card>
      <mat-progress-bar mode="indeterminate" *ngIf="loadingDossier"></mat-progress-bar>
      <mat-card-actions align="end">
        <button mat-stroked-button (click)="openAccordion($event)">{{ getButtonOpenCloseLabel() }}</button>
        <button mat-mini-fab color="primary" aria-label="Télèchargement Zip"
                *ngIf="hiddeButtonZip(dossier)"
                matTooltip="Exporter le zip du dossier"
                (click)="exportZipAttachementsDar(dossier)">
          <mat-icon>folder_zip</mat-icon>
        </button>
      </mat-card-actions>
      <mat-card-content>
        <app-state-chip [dossier]="dossier"></app-state-chip>
        <mat-accordion [multi]="true" #accordeon="matAccordion">

          <!-- Gestion du dossier -->

          <app-section-dipefas *ngIf="dossier && (hasRoleGestion$ | async)"
                               [dossier]="dossier"></app-section-dipefas>

          <!-- Affichage des différentes section du dossier -->

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>face</mat-icon>
                 Population
              </mat-panel-title>
              <mat-panel-description>
                Type de population ciblée (BIATSS/Enseignents,...)
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item>
                <h5 mat-line>Type de population</h5>
                <!--<mat-label>{{dossier?.type_demande_obj?.label}}</mat-label>-->
                <p mat-line>
                  <span>{{dossier?.type_demande_obj?.label}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>subject</mat-icon>
                Poste
              </mat-panel-title>
              <mat-panel-description>
                Détails concernant le poste
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item>
                <h5 mat-line>Motivation de la demande</h5>
                <p mat-line>
                  <span>{{dossier?.motivation_obj?.label}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item>
                <h5 mat-line>Motif / Description de la demande</h5>
                <p mat-line>
                  <span [innerHTML]="dossier?.motif | newline"></span>
                </p>
                <p mat-line><mat-divider></mat-divider></p>
              </mat-list-item>


              <mat-list-item>
                <h5 mat-line>Dernier occupant sur le poste</h5>
                <p mat-line>
                  <span>{{dossier?.last_occupant_first_name}} {{dossier?.last_occupant_last_name}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item>
                <h5 mat-line>Intitulé du poste</h5>
                <p mat-line>
                  <span>{{(dossier.intitule_obj?dossier.intitule_obj.label:'/')}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item>
                <h5 mat-line>Intitulé du poste si non renseigné</h5>
                <p mat-line>
                  <span>{{(dossier.intitule_poste_autre?dossier.intitule_poste_autre:'/')}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item>
                <h5 mat-line>Catégorie ou équivalence</h5>
                <p mat-line>
                  <span>{{(dossier.categorie_obj?dossier.categorie_obj.label:'non renseigné')}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>euro_symbol</mat-icon>
                Imputation budgétaire
              </mat-panel-title>
              <mat-panel-description>
                Détails concernant le budget
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item>
                <h5 mat-line>Rémunération</h5>
                <p mat-line>
                  <span>{{(dossier.remuneration_obj?dossier.remuneration_obj.label:'non renseigné')}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item>
                <h5 mat-line>Convention / opération</h5>
                <p mat-line>
                  <span>{{dossier.convention_obj?.numero_operation}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item>
                <h5 mat-line>UB</h5>
                <p mat-line>
                  <span>{{dossier.convention_obj?.ub}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item>
                <h5 mat-line>CR</h5>
                <p mat-line>
                  <span>{{dossier.convention_obj?.cr}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item>
                <h5 mat-line>S/CR</h5>
                <p mat-line>
                  <span>{{dossier.convention_obj?.scr}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item>
                <h5 mat-line>LOLF</h5>
                <p mat-line>
                  <span *ngIf="dossier.code_lolf_obj?.lolf_libelle">{{dossier.code_lolf_obj?.lolf_libelle}}</span>
                </p>
                <p mat-line>
                  <span>Code :</span>
                  <span> {{dossier.code_lolf_obj?.lolf_code}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item>
                <h5 mat-line>Code analytique</h5>
                <p mat-line>
                  <span>{{dossier.code_analytique_obj?.can_libelle}}</span>
                </p>
                <p mat-line>
                  <span>Code :</span>
                  <span> {{dossier.code_analytique_obj?.can_code}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>transfer_within_a_station</mat-icon>
                Affectation
              </mat-panel-title>
              <mat-panel-description>
                Détails liés à l'affectation du poste
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item>
                <h5 mat-line>Direction / Composante</h5>
                <p mat-line>
                  <span *ngIf="dossier.dir_cmp_obj">{{dossier.dir_cmp_obj?.name}} ({{dossier.dir_cmp_obj?.code}})</span>
                  <span *ngIf="! dossier.dir_cmp_obj">/</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item>
                <h5 mat-line>Service / Département / Labo</h5>
                <p mat-line>
                  <span *ngIf="dossier.svc_dep_obj">{{dossier.svc_dep_obj?.name}} ({{dossier.svc_dep_obj?.code}})</span>
                  <span *ngIf="! dossier.svc_dep_obj">/</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item>
                <h5 mat-line>Localisation/Lieux de travail</h5>
                <p mat-line>
                  <span>{{dossier.localisation ? dossier.localisation : '/'}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
            </mat-list>
          </mat-expansion-panel>

          <!-- période initiale, avant commission -->

          <mat-expansion-panel *ngIf="!ifAfterDRh(dossier.state)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>date_range</mat-icon>
                Période de recrutement demandée
              </mat-panel-title>
              <mat-panel-description>
                Date de début, date de fin, durée
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item>
                <h5 mat-line>Période</h5>
                <p mat-line>
                  <span>Du {{dossier.date_debut | date: 'dd/MM/yyyy'}}</span> <span> au {{dossier.date_fin | date: 'dd/MM/yyyy'}}</span>
                  <span> (durée: {{dossierService.getDaysBetweenDates(dossierService.getDateFromString(dossier.date_debut),
                                                                      dossierService.getDateFromString(dossier.date_fin))}} jours)</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <!-- selon type rémunération -->

              <mat-list-item *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.indiciaire">
                <h5 mat-line>Quotité</h5>
                <p mat-line>
                  <span>{{(dossier.quotite?dossier.quotite:'non renseigné')}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.horaire">
                <h5 mat-line>Vacation horaire</h5>
                <p mat-line>
                  <span>{{(dossier.vacation_horaires?dossier.vacation_horaires:'non renseigné')}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
            </mat-list>
          </mat-expansion-panel>

          <!-- période après DRH, retenue commission -->

          <mat-expansion-panel *ngIf="ifAfterDRh(dossier.state)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>date_range</mat-icon>
                Période de recrutement retenue commission
              </mat-panel-title>
              <mat-panel-description>
                Date de début, date de fin, durée
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item>
                <h5 mat-line>Période</h5>
                <p mat-line>
                  <span>Du {{dossier.date_debut_validee | date: 'dd/MM/yyyy'}}</span> <span> au {{dossier.date_fin_validee | date: 'dd/MM/yyyy'}}</span>
                  <span> (durée: {{dossierService.getDaysBetweenDates(dossierService.getDateFromString(dossier.date_debut_validee),
                                                                      dossierService.getDateFromString(dossier.date_fin_validee))}} jours)</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <!-- selon type rémunération -->

              <mat-list-item *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.indiciaire">
                <h5 mat-line>Quotité</h5>
                <p mat-line>
                  <span>{{(dossier.quotite_validee?dossier.quotite_validee:'non renseigné')}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.horaire">
                <h5 mat-line>Vacation horaire</h5>
                <p mat-line>
                  <span>{{(dossier.vacation_horaires_validee?dossier.vacation_horaires_validee:'non renseigné')}}</span>
                </p>
                <mat-divider></mat-divider>
              </mat-list-item>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>attach_file</mat-icon>
                Pièces jointes
              </mat-panel-title>
              <mat-panel-description>
                Pièces justificatives
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-list>
              <ng-container *ngIf="dossier?.attachedfiles_obj && dossier?.attachedfiles_obj.length > 0;then attached_files else nothing"></ng-container>
              <ng-template #attached_files>
                <mat-list-item>
                  <h5 mat-line>Pièces jointes</h5>
                    <p mat-line *ngFor="let attached_file of getPieceJointes()" style="padding-bottom: 5px">
                      <button (click)="onDownload($event, attached_file)"
                              mat-raised-button matTooltip="Télécharger ce fichier">
                        <mat-icon>file_download</mat-icon>
                        <i class="fa {{getPicto(attached_file)}}" aria-hidden="true"></i>&nbsp;{{getLabelButton(attached_file)}}
                      </button>

                      <app-file-preview [file]="attached_file"></app-file-preview>
                    </p>
                </mat-list-item>
              </ng-template>
              <ng-template #nothing>
                <mat-list-item>
                  <h5 mat-line>Pièces jointes</h5>
                  <p mat-line>
                    <span>Il n'y a pas de pièces jointes pour cette demande</span>
                  </p>
                </mat-list-item>
              </ng-template>
            </mat-list>
          </mat-expansion-panel>

        </mat-accordion>

      </mat-card-content>
    </mat-card>
  </p8-layout-settings-page>
</mat-drawer-container>
